// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__aexW4","header":"MergedInvoice_header__3zv_s"};